import { useState, useEffect } from "react";
import { Box, Button, Divider, Grid, IconButton, InputAdornment, Paper, Snackbar } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestionSquare, faEdit, faCheck, faHorizontalRule, faCheckSquare, faTimesSquare } from "@fortawesome/pro-duotone-svg-icons";
import { blue, grey, green, red } from "@material-ui/core/colors";
import SimpleTextField from "./SimpleTextField";
const BlueButton = withStyles((theme) => ({
    root: {
        color: theme.palette.getContrastText(blue[500]),
        backgroundColor: blue[500],
        "&:hover": {
            backgroundColor: blue[700],
        },
    },
}))(Button);
const GreenButton = withStyles((theme) => ({
    root: {
        color: theme.palette.getContrastText(green[500]),
        backgroundColor: green[500],
        "&:hover": {
            backgroundColor: green[700],
        },
    },
}))(Button);


const UserNameField = ({ props, autofilldomain, showFormHelp, fieldHelpText, checkedUsername, validateUsername, setValidusername, usernameValidMsg }) => {
    
    const [currentDomain, setCurrentDomain] = useState(
        Array.isArray(autofilldomain) ? autofilldomain[0] : autofilldomain
    );

   
    const DomainDropdown = (
        <Box display="inline-block" px={1}>
            <FontAwesomeIcon icon={faHorizontalRule} transform={{ rotate: 90 }} />
            <select 
                value={currentDomain} 
                onChange={(e) => setCurrentDomain(e.target.value)}
                style={{ border: 'none', background: 'transparent', fontWeight: 'bold', cursor: 'pointer', outline: 'none' }}
            >
                {Array.isArray(autofilldomain) 
                    ? autofilldomain.map(d => <option key={d} value={d}>{d}</option>)
                    : <option value={autofilldomain}>{autofilldomain}</option>
                }
            </select>
            <FontAwesomeIcon icon={faHorizontalRule} transform={{ rotate: 90 }} />
        </Box>
    );

    const [checkUsernameBtn, setCheckUsernameBtn] = useState("");
    const [validBtn, setValidBtn] = useState("");

    useEffect(() => {
       
        const fullUsername = `${props.values.username}${currentDomain}`;

        if (checkedUsername && checkedUsername === fullUsername) {
            setValidBtn(
                <InputAdornment position='start'>
                    <Box color={green[500]}><FontAwesomeIcon icon={faCheckSquare} /></Box>
                </InputAdornment>
            );
            setCheckUsernameBtn(
                <InputAdornment position='end'>
                    {DomainDropdown}
                    <GreenButton>Valid User Name</GreenButton>
                </InputAdornment>
            );
        } else if (checkedUsername && checkedUsername !== fullUsername) {
            setValidBtn(
                <InputAdornment position='start'>
                    <Box color={red[500]}><FontAwesomeIcon icon={faTimesSquare} /></Box>
                </InputAdornment>
            );
            setCheckUsernameBtn(
                <InputAdornment position='end'>
                    {DomainDropdown}
                    <BlueButton variant='outlined' onClick={() => validateUsername(fullUsername)}>
                        Check User Name
                    </BlueButton>
                </InputAdornment>
            );
            setValidusername("invalid");
        } else {
            if (props.values.username) {
                props.values.username = props.values.username.replace(/([^a-zA-Z0-9._-])/g, "").toLowerCase();
                if (props.values.username.length > 2) {
                    setCheckUsernameBtn(
                        <InputAdornment position='end'>
                            {DomainDropdown}
                            <BlueButton variant='outlined' onClick={() => validateUsername(fullUsername)}>
                                Check User Name
                            </BlueButton>
                        </InputAdornment>
                    );
                }
            } else {
                setCheckUsernameBtn(
                    <InputAdornment position='end'>
                        {DomainDropdown}
                        <IconButton disabled><FontAwesomeIcon icon={faEdit} size='sm' /></IconButton>
                    </InputAdornment>
                );
                setValidBtn("");
            }
        }
    }, [props.values.username, checkedUsername, currentDomain]);

    return (
        <Grid container spacing={1} alignItems='flex-end'>
            <Grid item xs={12}>
                <SimpleTextField
                    props={props}
                    fieldname={"username"}
                    fieldtype={"text"}
                    fieldlabel={"User Name"}
                    fieldrequired={true}
                    showFormHelp={showFormHelp}
                    fieldHelpText={fieldHelpText}
                    fieldValidationText={usernameValidMsg}
                    endAdornment={checkUsernameBtn}
                    startAdornment={validBtn}
                />
            </Grid>
        </Grid>
    );
};
export default UserNameField;